import {DownloadOutlined, RedoOutlined, ShareAltOutlined, UndoOutlined, SyncOutlined} from "@ant-design/icons";
import {Button, Col, Modal, Row, Tabs} from "antd";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {xcService} from "../../_services/xcService";
import "./avatar.scss"
import html2canvas from 'html2canvas';
import downloadjs from 'downloadjs';

import {ShareSocial} from 'react-share-social'
export const Avatar = ({user, wAction, onChange, itemGroups, noHave, itemsGroup}) => {
    const {t} = useTranslation();
    const [items, setItems] = useState();
    const [activeItems, setActiveItems] = useState();
    const [baseItems, setBaseItems] = useState();
    const [backgroundItems, setBackgroundItems] = useState();
    const [gender, setGender] = useState();
    const [userGender, setUserGender] = useState();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [link, setLink] = useState(null);

    useEffect( () => {
        if (user.gender){
            if (user.gender === "f"){
                setUserGender("female")
            }else{
                setUserGender("male")
            }
        }else{
            setUserGender("male")
        }
    },[user])

    const random = () => {

        xcService.putToken('/v1/student/avatarrandom')
            .then((res) =>{
                xcService.getToken('/v1/student/avatar')
                    .then((res) => setItems(res.data.data))
                    .catch();
            })
            .catch();

    }
    const resetAvatar = () => {
        xcService.deleteToken('/v1/student/avatar')
            .then((res) => {
                xcService.getToken('/v1/student/avatar')
                    .then((res) => setItems(res.data.data))
                    .catch();
            })
            .catch();
    }

    const getActive = (className, attribute) => {

        return activeItems
            .filter(item => item.gender === gender || item.gender === null)
            .find(item => item.class === className && item.name === attribute)?.value
    }

    const getGender = () => gender === 'male' ? 'hombre' : gender === 'female' ? 'mujer' : undefined;

    const getItems = () => xcService.getToken('/v1/student/avatar')
        .then((res) => setItems(res.data.data))
        .catch();

    const getBaseItems = () => xcService.getToken(`/v1/avatar/group/${'BASE'}/items`)
        .then((res) => setBaseItems(res.data.data))
        .catch();

    const getBackgroundItems = () => xcService.getToken(`/v1/avatar/group/${'BACKGROUND'}/items`)
        .then((res) => setBackgroundItems(res.data.data))
        .catch();

    const setStudentItem = (className, name, newValue, gender) =>
        xcService.putToken('/v1/student/avatar',
            {className, name, newValue, gender});

    const updateItem = (className, name, value, gender) => {
        setStudentItem(className, name, value, gender)
            .then(() => getItems())
    }


    useEffect(() => {
            getItems();
            getBaseItems();
            getBackgroundItems();
        },
        []);

    useEffect(() => {
            if (!items) return;

            const aa = items
                .filter(item => item.isActive)
                .map(item => item.avatar_item);

            setActiveItems(aa)
            setGender(aa.find(item => item.name === 'skin')?.gender ?? 'male');
        },
        [items]);

    useEffect(() => {

        if (activeItems) {
            activeItems && setGender(activeItems.find(item => item.name === 'skin')?.gender ?? 'male');
        }
    }, [activeItems])

    const descargaAvatar = async () => {
        const input = document.getElementById('myAvatar');
        const canvas = await html2canvas(input,{
            scale: 1});
        const dataURL = canvas.toDataURL('image/png');
        downloadjs(dataURL, 'myAvatar.png', 'image/png');
    }


    const shareAvatar = async () => {
        const input = document.getElementById('myAvatar');
        const canvas = await html2canvas(input);
        const dataURL = canvas.toDataURL('image/png');
        setLink(dataURL)
        setIsModalOpen(true);
    }



    const handleOk = () => {
        setLink(null);
        setIsModalOpen(false);
    };

    return (
        activeItems?.length > 0 &&
        baseItems?.length > 0 &&
        backgroundItems?.length > 0 &&
        gender &&
        <div className={"tuavatar card card--right"}>

            <Modal title={t("compartirrec")} open={isModalOpen} onOk={handleOk} onCancel={handleOk}>

                <ShareSocial

                    url ={link}
                    socialTypes={['facebook','twitter','reddit','linkedin','whatsapp','email']}
                />
            </Modal>


            <h2>{t("hi")} {user.name ?? ""}!</h2>
            <div className={"sigue"}>{t("miavatar")}</div>
            <div className={"subsigue"}>{t("consigue")}</div>
            <div id={"myAvatar"} className={"showavatar avatar__background"}
                 background={getActive('avatar__background', 'background')}
            >
                <div className="container-avatar"
                     skin={
                         getActive('container-avatar', 'skin') ??
                         baseItems.find(item => item.class === 'container-avatar').value
                     }
                >
                    <div className="container-avatar__eyes"
                         eyes={getActive('container-avatar__eyes', 'eyes')}
                    />
                    <div className="container-avatar__mouth"
                         mouth={getActive('container-avatar__mouth', 'mouth')}
                    />
                    <div className="container-avatar__hair"
                         hair={getActive('container-avatar__hair', 'hair')}
                         vellus={getActive('container-avatar__hair', 'vellus')}
                    />
                    <div className="container-avatar__accessory"
                         accessory={getActive('container-avatar__accessory', 'accessory')}
                    />
                    <div
                        className="container-avatar__tools"
                        tools={getActive('container-avatar__tools', 'tools')}
                    />
                    <div className="container-avatar__clothing"
                         look={getActive('container-avatar__clothing', 'look')}
                         pants={getActive('container-avatar__clothing', 'pants')}
                         tshirt={getActive('container-avatar__clothing', 'tshirt')}
                    />
                    <div
                        className="container-avatar__shoes"
                        shoes={getActive('container-avatar__shoes', 'shoes')}
                    />
                </div>

            </div>
            <div className={"twocolsav"}>
                <div className={"twocol_col aLeft"} style={{marginLeft: 5}}>
                    {1 == 2 && <a className={"is-blue"} onClick={() => shareAvatar()}>{t("compartir")} &nbsp;<ShareAltOutlined/></a>}
                </div>
                <div className={"twocol_col aRight"} style={{marginRight: 15}}>
                    <a className={"is-blue"} onClick={ () => descargaAvatar() }>{t("descargar")} &nbsp;<DownloadOutlined/></a>
                </div>
            </div>
            <div className={"avatar-container-buttons"}>
                <div className={""}>
                    <Button
                        icon={<SyncOutlined/>}
                        onClick={() => random()}

                        className="primaryButton btnWhiteBlue"
                    >
                        {t("random")}
                    </Button>
                </div>
                <div className={""}>
                    <Button
                        icon={<RedoOutlined/>}
                        onClick={() => resetAvatar()}

                        className="primaryButton btnWhiteBlue"
                    >
                        {t("avatar.reset")}
                    </Button>
                </div>
            </div>

            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab={t("avatar.silueta")} key="1">
                    <div className={"containerItemsAvatar"}>
                        {baseItems.filter(item => item.class === 'container-avatar')
                            .map((item) => {
                                    const immg = require(`../../assets/img/avatar/cuerpos-base/${item.gender === 'male' ? 'hombre' : 'mujer'}/${item.value}.png`)
                                    return <div key={item.value} className={"itemAvatar itemAvatar--silueta"}
                                                onClick={() => updateItem(item.class, item.name, item.value, item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("avatar.fondo")} key="9">
                    <div className={"containerItemsAvatar"}>
                        {backgroundItems.filter(item => item.class === 'avatar__background')
                            .map((item) => {
                                    const immg = require(`../../assets/img/avatar/fondos/${item.value}.jpg`)

                                    return <div key={item.id}  className={"itemAvatar"}
                                                onClick={() => updateItem(item.class, item.name, item.value, item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("avatar.ojos")} key="2">
                    <div className={"containerItemsAvatar"}>
                        {items.filter(({avatar_item}) => avatar_item.class === 'container-avatar__eyes' && avatar_item.gender === gender)
                            .map(({avatar_item}) => {
                                    const immg = require(`../../assets/img/avatar/fisonomia/${getGender()}/ojos/${avatar_item.value}.png`)
                                    return <div key={avatar_item.id}  className={"itemAvatar"}
                                                onClick={() => updateItem(avatar_item.class, avatar_item.name, avatar_item.value, avatar_item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("avatar.boca")} key="3">
                    <div className={"containerItemsAvatar"}>
                        {items.filter(({avatar_item}) => avatar_item.class === 'container-avatar__mouth' && avatar_item.gender === gender)
                            .map(({avatar_item}) => {
                                    const immg = require(`../../assets/img/avatar/fisonomia/${getGender()}/boca/${avatar_item.value}.png`)
                                    return <div  key={avatar_item.id} className={"itemAvatar"}
                                                onClick={() => updateItem(avatar_item.class, avatar_item.name, avatar_item.value, avatar_item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("avatar.pelo")} key="4">
                    <div className={"containerItemsAvatar"}>
                        {items.filter(({avatar_item}) => avatar_item.class === 'container-avatar__hair' && avatar_item.gender === gender)
                            .map(({avatar_item}) => {
                                    const immg = require(`../../assets/img/avatar/fisonomia/${getGender()}/pelo/${avatar_item.value}.png`)
                                    return <div key={avatar_item.id}  className={"itemAvatar"}
                                                onClick={() => updateItem(avatar_item.class, avatar_item.name, avatar_item.value, avatar_item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("avatar.ropa")} key="5">
                    <div className={"containerItemsAvatar"}>
                        {items.filter(({avatar_item}) => avatar_item.class === 'container-avatar__clothing' && avatar_item.gender === gender)
                            .map(({avatar_item}) => {
                                    const immg = require(`../../assets/img/avatar/ropa/${getGender()}/${avatar_item.value}.png`)
                                    return <div key={avatar_item.id}  className={"itemAvatar"}
                                                onClick={() => updateItem(avatar_item.class, avatar_item.name, avatar_item.value, avatar_item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("avatar.calzado")} key="6">
                    <div className={"containerItemsAvatar"}>
                        {items.filter(({avatar_item}) => avatar_item.class === 'container-avatar__shoes' && avatar_item.gender === gender)
                            .map(({avatar_item}) => {
                                    const immg = require(`../../assets/img/avatar/calzado/${getGender()}/${avatar_item.value}.png`)
                                    return <div key={avatar_item.id}  className={"itemAvatar"}
                                                onClick={() => updateItem(avatar_item.class, avatar_item.name, avatar_item.value, avatar_item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("avatar.accesorios")} key="7">
                    <div className={"containerItemsAvatar"}>
                        {items.filter(({avatar_item}) => avatar_item.class === 'container-avatar__accessory' &&
                            (avatar_item.gender === gender || !avatar_item.gender))
                            .map(({avatar_item}) => {
                                    const immg = avatar_item.gender ?
                                        require(`../../assets/img/avatar/accesorios/${getGender()}/${avatar_item.value}.png`) :
                                        require(`../../assets/img/avatar/accesorios/${avatar_item.value}.png`)
                                    return <div key={avatar_item.id}  className={"itemAvatar"}
                                                onClick={() => updateItem(avatar_item.class, avatar_item.name, avatar_item.value, avatar_item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("avatar.herramientas")} key="8">
                    <div className={"containerItemsAvatar"}>
                        {items.filter(({avatar_item}) => avatar_item.class === 'container-avatar__tools' &&
                            (avatar_item.gender === gender || !avatar_item.gender))
                            .map(({avatar_item}) => {
                                    const immg = require(`../../assets/img/avatar/elementos-herramientas/${avatar_item.value}.png`)
                                    return <div key={avatar_item.id}  className={"itemAvatar"}
                                                onClick={() => updateItem(avatar_item.class, avatar_item.name, avatar_item.value, avatar_item.gender)}>
                                        <img style={{'width': '5em', 'height': 'auto'}}
                                             src={immg.default}
                                            /*className={`${noHave(item.id) ? 'nohave' : 'have'}`}*//>
                                    </div>
                                }
                            )
                        }
                    </div>
                </Tabs.TabPane>

            </Tabs>
        </div>

    )
}
